export const profilesCache = {
  all(): TProfileCacheAll {
    return ["profiles"]
  },

  lists(): TProfileListsCache {
    return [...this.all(), "list"]
  },

  items(): TProfileItemsCache {
    return [...this.all(), "item"]
  },
  item(id: string): TProfileItemCache {
    return [...this.items(), id]
  },
}

type TProfileCacheAll = ["profiles"]

type TProfileListsCache = ["profiles", "list"]

type TProfileItemsCache = [...TProfileCacheAll, "item"]
export type TProfileItemCache = [...TProfileItemsCache, string]
